import Api from "../api";
import { AdviserModel, TinkTankModel } from "../model/AboutModel";
import { HomeModel, SearchReq } from "../model/HomeModel";
import { ActivityModel, MemberModel, NewsModel, PolicyModel } from "../model/OtherModel";
import http from "./http";

export const HomeServices = {
  index: () => {
    return http.get<HomeModel>(Api.index);
  },
  search: (keyword: string) => {
    return http.post<SearchReq, any>(Api.search, { keyword });
  },
  details: ({
    url,
    uuid,
    methods,
  }: {
    url: string;
    uuid: string;
    methods: "get" | "post";
  }) => {
    if (methods === "get") {
      return http.get<any, any>(url, { params: { uuid } });
    } else {
      return http.post<any, any>(url, { uuid });
    }
  },
};

export const AboutServices = {
  adviser: () => {
    return http.get<AdviserModel>(Api.adviser);
  },
  tinkTank: () => {
    return http.get<TinkTankModel>(Api.tink_tank);
  },
};

export const ActivityServices = {
  activity: ({
    page,
    category,
    time,
  }: {
    page: number;
    category: number;
    time: number;
  }) => {
    return http.get<ActivityModel>(Api.activity, {
      params: { page, category, time },
    });
  },
};

export const MemberService = {
  member: (page: number) => {
    return http.get<MemberModel>(Api.member, { params: { page } });
  },
};

export const PolicyServices = {
  policy: ({
    page,
    category,
    time,
  }: {
    page: number;
    category: number;
    time: number;
  }) => {
    return http.get<PolicyModel>(Api.policy, {
      params: { page, category, time },
    });
  },
};

export const NewsServices = {
  news: ({
    page,
    category,
    time,
    year,
  }: {
    page: number;
    category: number;
    time: number;
    year:string
  }) => {
    return http.get<NewsModel>(Api.news, {
      params: { page, category, time,year },
    });
  },
  media: ({
    page,
    category,
    time,
    year,
  }: {
    page: number;
    category: number;
    time: number;
    year?:string
  }) => {
    return http.get<NewsModel>(Api.media, {
      params: { page, category, time,year },
    });
  },
};
